package com.patronat.top.client.di

import com.patronat.top.client.presentation.auth.ClientAuthViewModel
import org.koin.dsl.module

val clientAuthModule = module {
    factory {
        ClientAuthViewModel(
            alertController = get(),
            startLoginUseCase = get(),
            startRegistrationUseCase = get(),
            confirmPhoneUseCase = get(),
            resendPhoneCodeUseCase = get()
        )
    }
}
